(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory( 'action-get-model', actionFunc);

    function actionFunc(GenericModel, lodash) {
        const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.;
        return function(asyncOptions, model) {
            let asyncUrl = asyncOptions.url;
            const method = lodash.get(asyncOptions, 'method', 'get');

            asyncUrl = decodeURI(asyncUrl).replace(urlReplacerRegex, (match, submatch) => {
                return lodash.get(model, submatch, '');
            });

            const resource = new GenericModel(asyncUrl);
            return resource[method]().$promise.then(function(res) {
                return res;
            }, function() {
                return arguments;
            });
        };
    }
})();